import { GetServerSideProps } from 'next';
import { useContext, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { PacksContext } from '@/components/app/layout/PacksProvider';
import ProfileHome from '@/components/app/profile/ProfileHome';
import ProfileLayout from '@/components/app/profile/ProfileLayout';
import Layout from '@/components/layout/LayoutWrapper';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

export const messages = defineMessages({
	title: {
		id: 'app.components.ScreenTitle.profileTabTitle',
		defaultMessage: 'Profile',
		description: "Title for the page to view the user's profile information",
	},
});

const Profile = () => {
	const { formatMessage } = useIntl();
	const { setPageTitle } = useContext(PacksContext);

	useEffect(() => {
		setPageTitle(formatMessage(messages.title));
	}, [setPageTitle, formatMessage]);

	return (
		<Layout pageName="profile">
			<ProfileLayout hideNav>
				<ProfileHome />
			</ProfileLayout>
		</Layout>
	);
};

export default Profile;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
